import { ERewardAssetType } from "../@types/appConfig.js";
import { truncateString } from "./string-format.js";
export const getAssetName = (asset, truncateFrom = 6, truncateUntil = 2) => {
    if (!asset) {
        return "";
    }
    const { ticker, assetName } = asset;
    return truncateString(ticker || assetName || "", truncateFrom, truncateUntil);
};
export const getFirstClaimableAsset = () => {
    const assetType = window.__APP_CONFIG.rewardAssets[0];
    switch (assetType.type) {
        case ERewardAssetType.ASSET:
            return `${assetType.policyId}.${assetType.assetName}`;
        case ERewardAssetType.POLICY:
            throw new Error("Policy ID is not a currently supported reward type. Please use the Asset type instead.");
        default:
            throw new Error("Compatible type not found for claimable asset.");
    }
};
export const getClaimableAssets = () => {
    let assetIds = [];
    const rewardAssets = window.__APP_CONFIG.rewardAssets;
    rewardAssets.forEach((asset) => {
        switch (asset.type) {
            case ERewardAssetType.POLICY:
                return;
            case ERewardAssetType.ASSET:
                assetIds.push(`${asset.policyId}.${asset.assetName}`);
            default:
                throw new Error(`Invalid reward asset found in your config. Got reward asset of type: ${asset.type}`);
        }
    });
    return assetIds;
};
//# sourceMappingURL=assets.utils.js.map